import React from "react";
import "./testimonials.css";
import CLIENT1 from "../../assets/avatar4.jpg";
import CLIENT2 from "../../assets/avatar1.jpg";
import CLIENT3 from "../../assets/avatar2.jpg";
import CLIENT4 from "../../assets/avatar3.jpg";
import { Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const data = [
  {
    avatar: CLIENT1,
    name: "Kylie Collazo",
    review:
      "Very helpful when building my website, I now have my business website built from scratch.",
  },
  {
    avatar: CLIENT2,
    name: "George Peterson",
    review:
      "Fantastic service and great programmer. We recommend her to any small business who needs a website!",
  },
  {
    avatar: CLIENT3,
    name: "Daniel Morales",
    review:
      "Just thought Id share something with you about my website. I have had so much positive feedback from clients and family on how great the site looks.Thank you for making it look so professional!",
  },
  {
    avatar: CLIENT4,
    name: "Heather Moradi",
    review:
      "Always available to help, incredibly proficient, her deadlines without fail, hard working and trustworthy. In my experience, no project is too much trouble.",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials">
      <h5>Reviews from clients</h5>
      <h2>Testimonials</h2>

      <Swiper
        className="container testimonials__container"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {data.map(({ avatar, name, review }, index) => {
          return (
            <SwiperSlide key={index} className="testimonial">
              <div className="client__avatar">
                <img src={avatar} alt="" />
              </div>
              <h5 className="client__name">{name}</h5>
              <small className="client__review">{review}</small>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
